/**
 * Build metadata helpers for SPA version labels.
 * Hide the label only when deploy env is production.
 */

export function shouldShowBuildInfo(appEnv: string | undefined): boolean {
  return (appEnv ?? '').toLowerCase() !== 'production';
}

export function formatBuildInfoLabel(
  version: string | undefined,
  commit: string | undefined,
  commitDate: string | undefined,
): string {
  const v = (version ?? 'unknown').replace(/^v/i, '');
  const c = commit?.trim() || 'local';
  const d = commitDate?.trim();
  return d ? `v${v} · ${c} · ${d}` : `v${v} · ${c}`;
}
